import React from 'react'

import Reflux from 'reflux-react-16'
import _ from 'lodash'

import ShiftStore from '../../stores/ShiftStore.js'
import ShiftActions from '../../actions/ShiftActions.js'
import UserStore from '../../stores/UserStore.js'
import CustomerStore from 'src/stores/CustomerStore.js'
import OrderStore from 'src/stores/OrderStore.js'

import EditShiftModal from '../../components/shifts/EditShiftModal.js'
import {Button, Colors, IconButton, Panel, Popup, Tab, Tabs} from '../../components/UI/index.js'
import Table from '../../components/UI/table/index.js'
import SearchBar from '../../components/SearchBar/index.js'
import filter from '../../utils/filter.js'
import Languages from '@utils/Languages.js'
import {emit} from 'src/socketio/socketEmit.js'
import {RRule} from 'rrule'
import languages from 'server/languages.js'
import t from 'src/helpers/Languages.js'
import branchesAvailable from '@utils/branchesAvailable.js'
import {formSpacing} from '../../components/UI/forms/index.js'
import createMemo from '../../utils/createMemo.js'

export default class Shifts extends Reflux.Component {
    constructor(props) {
        super(props)

        this.columnsMemo = createMemo()

        this.stores = [ShiftStore, UserStore, CustomerStore, OrderStore]
    }

    componentDidMount() {
        const {reseller} = this.props
        document.title = `Diensten • ${reseller.settings.accountName || reseller.name}`
    }

    componentDidUpdate() {
        if (this.state.shiftLimitWarning) {
            this.setState({shiftLimitWarning: false})
            this.alertPopup.openAlert('Waarschuwing', 'Je huidige datumrange bevat meer dan 35 000 diensten, hierdoor worden niet alle diensten weergegeven. Verklein de datumrange om dit te voorkomen. ')
        }
    }

    // The same columns until a value they read changes: new columns re-render every row of the table
    columns() {
        return this.columnsMemo([this.props.reseller, this.state.customers, this.state.usersObject], () => this.buildColumns())
    }

    buildColumns() {
        const {reseller} = this.props

        return [
            ...branchesAvailable(reseller) ?
                [{id: 'branchName', title: t('branch'), visible: false, key: 'branchName', width: 180, text: (template) => {
                    const branch = reseller.settings.branches?.find((branch) => branch.id === template?.branchId)
                    return branch?.name || ''
                }}] :
                [],
            {id: 'name', title: Languages.name['NL'], visible: true, flex: 1, key: 'name'},
            {id: 'rrule', title: Languages.rrule['NL'], visible: true, flex: 1, key: 'rrule', text: (shift) => {
                if (!shift.rrule) return ''

                const language = languages.DUTCH
                return _.capitalize(RRule.fromString(shift.rrule).toText((t) => {
                    return language.rrule[t] || t
                }, language))
            }},
            {id: 'customerId', title: Languages.customer['NL'], visible: true, key: 'customerId', width: 300, text: (shift) => {
                const customer = this.state.customers[shift.customerId]
                return customer?.name || ''
            }},
            {id: 'messengerId', title: Languages.messenger['NL'], visible: true, key: 'messengerId', width: 300, text: (shift) => {
                const messenger = this.state.usersObject[shift.messengerId]
                return messenger?.name || ''
            }},
            {id: 'plannedStartTime', title: Languages.startTime['NL'], visible: true, width: 150, key: 'plannedStartTime'},
            {id: 'plannedEndTime', title: Languages.endTime['NL'], visible: true, width: 150, key: 'plannedEndTime'},
            {id: 'startPoint', title: Languages.startLocation['NL'], visible: true, key: 'startPoint', width: 150, text: (shift) => {
                return shift.startPoint ? `${shift.startPoint?.street || ''} ${shift.startPoint?.nr || ''}${shift.startPoint?.addtion || ''}, ${shift.startPoint?.city || ''}` : ''
            }},
            {id: 'endPoint', title: Languages.endLocation['NL'], visible: true, key: 'endPoint', width: 150, text: (shift) => {
                return shift.endPoint ? `${shift.endPoint?.street || ''} ${shift.endPoint?.nr || ''}${shift.endPoint?.addtion || ''}, ${shift.endPoint?.city || ''}` : ''
            }},
            {id: 'edit', visible: true, showOnHover: true, width: 50, render: (shiftTemplate) => {
                return (
                    <IconButton onClick={() => this.onClickEdit(shiftTemplate, true)}>
                        <i className='mdi mdi-pencil' />
                    </IconButton>
                )
            }}
        ]
    }

    onChangeQueries(queries) {
        this.table.selectPage(1)
        ShiftActions.setTemplateQueries(queries)
    }

    onChangeTable(selectedShiftTemplates) {
        ShiftActions.setSelectedTemplates(selectedShiftTemplates)
    }

    onClickNew() {
        this.modal.open(null, true)
        ShiftActions.setSelectedTemplates([])
    }

    onClickCopy() {
        const {shiftTemplates, selectedShiftTemplates} = this.state

        const id = selectedShiftTemplates[0]
        let shift = _.find(shiftTemplates, (shift) => shift._id === id)
        shift = JSON.parse(JSON.stringify(shift))
        delete shift._id
        delete shift.rrule
        delete shift.templateId
        delete shift.messenger
        this.modal.open(shift, true)
        ShiftActions.setSelectedTemplates([])
    }

    onClickEdit(shiftTemplate) {
        this.modal.open(shiftTemplate, true)
        ShiftActions.setSelectedTemplates([])
    }

    async onClickRemove() {
        const {selectedShiftTemplates} = this.state

        if (!await this.popup.open('Dienst templates verwijderen', 'Dienst templates worden definitief verwijderd.')) return

        try {
            await emit('shifts.removeTemplates', selectedShiftTemplates)

            ShiftActions.setSelectedTemplates([])
            this.popup.close()
        } catch (err) {
            this.popup.setError(err)
        }
    }

    render() {
        const {selectedShiftTemplates, shiftTempaltesLoading, shiftTemplateQueries, usersObject, customers, routeTemplates} = this.state
        const {reseller, history} = this.props

        const shiftTemplates = filter.shiftTemplates(this.state.shiftTemplates, shiftTemplateQueries, reseller)

        return (
            <div style={{display: 'flex', flexDirection: 'column', height: '100%'}}>
                <Panel style={{display: 'flex', borderTop: 'none', borderLeft: 'none', borderRight: 'none'}}>
                    <Tabs
                        style={{width: 400, marginBottom: 1}}
                        value={history.location.pathname}
                        onChange={(event) => {
                            history.push(event.target.value)
                        }}
                    >
                        <Tab value='/diensten'>Diensten</Tab>
                        <Tab value='/diensttemplates'>Dienst templates</Tab>
                    </Tabs>
                </Panel>

                <Panel style={{display: 'flex', columnGap: formSpacing.columnGap, borderTop: 'none', borderLeft: 'none', borderRight: 'none', background: Colors.backgroundNeutral, padding: '20px 10px 10px 10px'}}>

                    <SearchBar
                        columns={this.columns()}
                        onQueryChange={this.onChangeQueries.bind(this)}
                        queries={shiftTemplateQueries}
                    />

                    <Button
                        variant='outline-white'
                        onClick={this.onClickNew.bind(this)}
                    >
                        Nieuw Dienst Template
                    </Button>

                    {selectedShiftTemplates.length === 1 &&
                        <Button
                            variant='outline-white'
                            onClick={this.onClickCopy.bind(this)}
                        >
                            <i className='mdi mdi-content-copy' />
                        </Button>
                    }

                    {selectedShiftTemplates.length > 0 &&
                        <>

                            <Button
                                variant='outline-white'
                                onClick={this.onClickRemove.bind(this)}
                            >
                                <i className='mdi mdi-delete' />
                            </Button>
                        </>
                    }
                </Panel>

                <div style={{flex: 1, marginTop: 24, marginRight: 24, marginLeft: 24}}>
                    <Table
                        tableName='shiftTemplates'
                        columns={this.columns()}
                        rows={shiftTemplates}
                        selectedRows={selectedShiftTemplates}
                        loading={shiftTempaltesLoading}
                        onChange={this.onChangeTable.bind(this)}
                        ref={(ref) => this.table = ref}
                    />
                </div>

                <EditShiftModal
                    reseller={reseller}
                    customers={customers}
                    users={usersObject}
                    routeTemplates={routeTemplates}
                    ref={(ref) => this.modal = ref}
                />

                <Popup ref={(ref) => this.popup = ref} />
                <Popup ref={(ref) => this.alertPopup = ref} />
            </div>

        )
    }
}
